<template>
    <div>
        <NumberFlow :format="{ style: 'currency', currency: 'GBP', trailingZeroDisplay: 'stripIfInteger' }" :value="total" :suffix="'/' + frequency_text" />
    </div>
</template>

<script>
import NumberFlow from '@number-flow/vue'
export default {
    props: ['total', 'frequency_text'],
    components: {NumberFlow},
}
</script>

<style lang="scss" scoped>
number-flow-vue::part(suffix) {
    margin-left: .0625em;
    font-weight: normal;
    font-size: 0.75em;
    color: grey;
}
</style>